import { useNavigate } from "react-router-dom";
import { FormFieldKeyActionEnum } from "../../../_common/enum/forms/formFieldKeyAction.enum";
import { IFormFieldKeyManage } from "../../../_common/models/formFieldKey";
import { PaperTableHeader } from "../../../_components/table/header.table";
import { FormSectionView } from "./formSection-view";
import { useState } from "react";

export function FormSectionManage(params: {
    formTemplateSectionId: number,
    formSectionId?: number,
    isSectionSaving?: boolean,
    isForReview?: boolean,
    actionId?: FormFieldKeyActionEnum,
    onSave: () => void,
    editable?: boolean,
    onEditFieldClick?: (field: IFormFieldKeyManage) => void,
}) {

    const [count, setCount] = useState(0);
    let navigate = useNavigate();

    function handleEmptyCellClick(tableField: IFormFieldKeyManage, row: number, col: number) {
        navigate(`CreateFormFieldKey?tableId=${tableField.id}&row=${row}&col=${col}`);
    }

    return (<> 
        <PaperTableHeader title="Form Manage" buttons={[
            { icon: "refresh", label: "Refresh", variant: "success", onClick: () => { setCount(count + 1) } },
            { icon: "add", label: "Create", onClick: () => { navigate("CreateFormFieldKey") } }
        ]} />
        <FormSectionView 
            {...params} 
            count={count} 
            onEmptyCellClick={params.editable ? handleEmptyCellClick : undefined}
        />
    </>);
}
